<template>
  <b-card class="card search-view-blogsearch">
    <router-link :to="{ name: 'blog-article', params: { ...results } }">
      <img
        v-if="results.cover"
        :src="results.cover"
        :alt="results.title"
        class="card-img-top img-fluid"
      />
      <img
        v-else-if="results.picture"
        :src="results.picture"
        :alt="results.title"
        class="card-img-top img-fluid"
      />
      <div class="card-body">
        <h5 class="card-title mt-2">{{ results.title }}</h5>
      </div>
    </router-link>
  </b-card>
</template>
<script>
export default {
  props: {
    results: {
      type: Object
    }
  }
};
</script>
<style lang="scss" scoped>
.search-view-blogsearch {
  background-color: rgba(0, 0, 0, 0.3);
  padding-bottom: 10%;
}
</style>
